import React from "react";
import { SanityPerson } from "../../model/common";
import BiographyPersonGrid from "./BiographyPersonGrid";
import CompactPersonGrid from "./CompactPersonGrid";

interface PersonGridProps {
  node: {
    people: SanityPerson[];
    layout: "compact" | "biography";
  };
}

export interface PersonGridLayoutProps {
  people: SanityPerson[];
}

const PersonGrid = ({ node: { people, layout } }: PersonGridProps) => {
  if (layout === "biography") {
    return <BiographyPersonGrid people={people} />;
  }
  return <CompactPersonGrid people={people} />;
};
export default PersonGrid;
